// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dispense/modules/dispense-view/components/dispense-kpi/dispense-kpi.less
// module id = 3384
// module chunks = 0